import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';

/**
 * DatePickerField component that ensures consistent styling across all browsers
 * including Safari and Chrome
 */
const DatePickerField = ({ 
  label, 
  name, 
  value, 
  onChange, 
  fullWidth = true, 
  size = 'small',
  ...props
}) => {
  return (
    <TextField
      type="date"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      size={size}
      InputLabelProps={{ shrink: true }}
      fullWidth={fullWidth}
      InputProps={{
        // Add a calendar icon for visual consistency
        endAdornment: (
          <InputAdornment position="end">
            <CalendarToday fontSize="small" color="action" />
          </InputAdornment>
        ),
        ...props.InputProps,
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'divider',
          },
          '&:hover fieldset': {
            borderColor: 'primary.main',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'primary.main',
          },
          '& input': {
            // Normalize date input appearance across browsers
            appearance: 'none',
            '-webkit-appearance': 'none',
            '-moz-appearance': 'none',
            height: '1.4375em',
            padding: '8.5px 14px',
            // Hide the default calendar icon in Safari and other browsers
            '::-webkit-calendar-picker-indicator': {
              opacity: 0,
              position: 'absolute',
              right: 0,
              top: 0,
              width: '100%',
              height: '100%',
              cursor: 'pointer',
            },
            // Hide clear button in Edge
            '::-ms-clear': {
              display: 'none',
            },
          },
        },
        '& .MuiInputLabel-root': {
          color: 'text.secondary',
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: 'primary.main',
        },
        ...props.sx
      }}
      {...props}
    />
  );
};

export default DatePickerField; 